import { Link } from "react-router-dom";
import { Gift } from "lucide-react";
import { PRIVACY_NOTICE } from "@/lib/privacy";
import { t } from "@/lib/i18n";
import { Footer } from "@/components/Footer";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-[#FDFBF7] flex flex-col">
      <div className="flex-1 max-w-2xl w-full mx-auto px-4 py-10 sm:py-16">
        <nav className="mb-8">
          <Link to="/" className="flex items-center gap-2 text-[#C86D51]">
            <Gift className="w-6 h-6" />
            <span className="text-sm font-semibold tracking-wide uppercase">Portwrite</span>
          </Link>
        </nav>
        <h1 className="font-serif text-4xl sm:text-5xl font-medium text-[#2C221E]">{t("privacy.title")}</h1>
        <div className="mt-4 rounded-2xl border border-[#E8DEC2] bg-white p-4 text-sm text-[#4A3E39] leading-relaxed" data-testid="legal-seller-details">
          <p><strong>Sunbnb España SL</strong> {t("privacy.tradingAs")}</p>
          <p>CIF: B22435705</p>
          <p>Calle Las Viñas 54, 29640 Fuengirola, Málaga, Espanja</p>
          <p>{t("common.contact")} <a href="mailto:hei@portwrite.com" className="text-[#B35A3E] hover:underline">hei@portwrite.com</a></p>
          <p className="mt-2 text-[#7A6B63]">{t("privacy.registrar")}</p>
        </div>
        <p className="mt-6 text-base sm:text-lg text-[#4A3E39] leading-relaxed" data-testid="privacy-notice-text">
          {PRIVACY_NOTICE}
        </p>
      </div>
      <Footer />
    </div>
  );
}
